import { Orders } from "modules/orders";

const CompanyAdminOrdersPage = () => <Orders />;

export default CompanyAdminOrdersPage;
